/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface RewriteSignature1$Params {}

export function rewriteSignature1(
  http: HttpClient,
  rootUrl: string,
  params?: RewriteSignature1$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<{}>> {
  const rb = new RequestBuilder(rootUrl, rewriteSignature1.PATH, 'post');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{}>;
    }),
  );
}

rewriteSignature1.PATH = '/service/v1/attachment/rewriteSignatures';
